export class Accordeon {

    init() {
        const accordions = [...document.querySelectorAll('.js-accordion')];

        if (accordions.length > 0) {
            accordions.forEach(accordion => {
                const cells = [...accordion.querySelectorAll('.js-accordion-cell')];
                const btns = [...accordion.querySelectorAll('.js-accordion-btn')];

                if (btns) {
                    btns.forEach(btn => btn.addEventListener('click', () => this.toggleAccordion(cells, btns, btn)))
                }
            })
        }
    }

    toggleAccordion(cells, btns, btn) {
        const pushedBtnOpen = btn.parentNode.classList.contains('open');

        btns.forEach(button => {
            const cell = button.parentNode;
            const cellContent = cell.querySelector('.accordion__content-wrapper');
            const open = cell.classList.contains('open');
            if (open) {
                cellContent.style.height = cellContent.scrollHeight + 'px';
                cell.classList.remove('open')
                setTimeout( () =>  cellContent.style.height = 0, 50 )
            }
        });
        if (!pushedBtnOpen) {
            const cell = btn.parentNode;
            const cellContent = cell.querySelector('.accordion__content-wrapper');
            cell.classList.add('open');
            cellContent.style.height = cellContent.scrollHeight + 'px';
            cellContent.addEventListener('transitionend', () => {
                if(cell.classList.contains('open')) {
                cellContent.style.height = 'auto';
                }
            });
        }
    }
}
